// MODIFIED: Replaced Lucide icon with the custom SVG Tower adapted from React Native to Web
// MODIFIED: Styled tower in offline gray with dashed broken waves and glowing red alert emitter
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: Signal lost at route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background relative overflow-hidden">
      {/* Subtle background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-background via-primary/5 to-background" />

      <div className="relative z-10 text-center flex flex-col items-center px-6">
        {/* Visual: Offline Radio Tower with broken signal */}
        <div className="relative mb-8 flex items-center justify-center w-56 h-56">
          {/* Fading radar rings simulating a dead/lost ping */}
          <div className="absolute w-48 h-48 rounded-full border border-destructive/10 animate-ping [animation-duration:3s]" />
          <div className="absolute w-64 h-64 rounded-full border border-muted/10 animate-ping [animation-duration:3s] [animation-delay:1.5s]" />
          
          {/* NEW: Custom Tower SVG (Adapted from RN to standard Web SVG) */}
          <div className="relative w-full h-full flex items-center justify-center z-10">
            <svg 
              viewBox="0 -20 200 320" 
              className="w-full h-full text-muted-foreground/30 drop-shadow-sm"
              fill="none"
            >
              {/* NEW: Broken / Offline Waves (Dashed & Fading) */}
              <g stroke="currentColor" strokeWidth="6" strokeLinecap="round" strokeDasharray="8 12" className="opacity-40">
                <path d="M 80 34.4 A 40 40 0 0 0 80 103.6" />
                <path d="M 120 34.4 A 40 40 0 0 1 120 103.6" />
                <path d="M 67.5 12.7 A 65 65 0 0 0 67.5 125.3" />
                <path d="M 132.5 12.7 A 65 65 0 0 1 132.5 125.3" />
              </g>

              {/* Tower Graphic - Greyed out offline state */}
              <g stroke="currentColor" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round">
                <rect x="25" y="260" width="150" height="20" rx="8" />
                <line x1="50" y1="260" x2="91" y2="82" />
                <line x1="150" y1="260" x2="109" y2="82" />
                <path d="M 50 260 L 139.5 215.5 L 71 171 L 118.5 126.5 L 91 82" />
                <path d="M 150 260 L 60.5 215.5 L 129 171 L 81.5 126.5 L 109 82" />
                
                {/* Emitter Base Circle */}
                <circle cx="100" cy="69" r="14" />
              </g>

              {/* NEW: Blinking Red Offline Indicator inside the Emitter */}
              <circle 
                cx="100" 
                cy="69" 
                r="8" 
                className="fill-destructive animate-pulse" 
                style={{ filter: "drop-shadow(0px 0px 8px rgba(239, 68, 68, 0.8))" }}
              />
            </svg>
          </div>
        </div>

        {/* Text Content */}
        <h1 className="mb-2 text-7xl font-display font-bold text-transparent bg-clip-text bg-gradient-to-b from-foreground to-foreground/40">
          404
        </h1>
        <h2 className="mb-4 text-2xl font-semibold text-foreground tracking-wide">
          Signal Lost
        </h2>
        <p className="mb-10 text-muted-foreground max-w-sm mx-auto leading-relaxed">
          We couldn't establish a connection to the page you're looking for. The signal dropped, or the route no longer exists.
        </p>
        
        {/* Action Button */}
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-primary text-primary-foreground hover:bg-primary/90 transition-all duration-300 shadow-sm hover:shadow-primary/25 hover:shadow-lg hover:-translate-y-0.5 font-medium"
        >
          <ArrowLeft className="w-4 h-4" />
          Return to Base
        </Link>
      </div>
    </div>
  ); 
};

export default NotFound;